<template>
  <div class="page-scroll-container" ref="pageContainer">
    <!-- 1. [底层] 清晰背景图 (始终可见，铺满屏幕) -->
    <!-- 注意：这里使用 require 引入本地图片，确保 webpack/vite 能正确打包 -->
    <img
      class="bg-layer clear-bg"
      src="../../../assets/annualReport/page7_coBranded_bac.png"
      alt="background"
    />

    <!-- 2. [中间层] 模糊/变暗背景图 (控制 Opacity 实现渐变) -->
    <!-- isVisible 为 true 时，添加 active 类，透明度变为 1，实现背景压暗聚焦效果 -->
    <img
      class="bg-layer blur-bg"
      :class="{ active: isVisible }"
      src="../../../assets/annualReport/page7_blur.png"
      alt="blur mask"
    />

    <!-- 3. [顶层] 核心卡片 -->
    <div class="visual-card" :class="{ 'start-anim': isVisible }">
      <!-- 3.1 卡片内部背景容器：模拟“聚光灯”下的清晰区域 -->
      <div class="card-bg-container">
        <img
          class="card-img"
          src="../../../assets/annualReport/page7_coBranded_bac.png"
          alt="card background"
        />
      </div>

      <!-- 3.2 卡片内容 (原有的品牌词和弹框) -->
      <div class="card-content">
        <!-- 前10个品牌词保持不变 -->
        <div>水龙吟</div>
        <div>名侦探柯南</div>
        <div>哪吒</div>
        <div>樱桃小丸子</div>
        <div>蜡笔小新</div>
        <div>非遗云锦</div>
        <div>小马宝莉</div>
        <div>KAKAO FRIENDS</div>
        <div>宝可梦</div>
        <div>Tom Brolga</div>

        <!-- 11. 标题 -->
        <div class="main-title">
          <span class="bracket">[</span>联名大事件<span class="bracket">]</span>
        </div>

        <!-- 弹框1：哪吒 -->
        <div class="pop-message nezha-message">
          <div class="message-box">
            <div class="message">
              <span class="special">3</span>月，「哪吒」项目，成功
            </div>
            <div class="message">
              闹起了一场<span class="pink-text">“库迪红海”</span>
            </div>
          </div>
        </div>

        <!-- 弹框2：樱桃小丸子 -->
        <div class="pop-message yingtao-message">
          <div class="message-box">
            <div class="message">
              <span class="special">5</span>月<span class="special">8</span
              >日，我们一起为
            </div>
            <div class="message">
              世界上<span class="pink-text">最可爱的「小丸子」</span>
            </div>
            <div class="message">同学庆祝9岁生日</div>
          </div>
        </div>

        <!-- 弹框3：Tom (小马谷文案) -->
        <div class="pop-message xiaoma-message">
          <div class="message-box">
            <div class="message">
              <span class="special">6</span>月，来自<span class="pink-text"
                >「小马谷」的信件</span
              >
            </div>
            <div class="message">又将我们拉入魔法的世界</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Page7CoBranded",

  data() {
    return {
      isVisible: false,
      observer: null,
    };
  },

  mounted() {
    // 进入页面时，给 body 加上锁
    document.body.classList.add("lock-scroll");
    const vm = this;

    vm.observer = new IntersectionObserver(
      function (entries) {
        const entry = entries[0];

        if (entry.isIntersecting) {
          console.log("Page7 进入视野");
          vm.isVisible = true;
        } else {
          console.log("Page7 离开视野");
          vm.isVisible = false;
        }
      },
      { threshold: 0.5 }
    );

    if (vm.$refs.pageContainer) {
      vm.observer.observe(vm.$refs.pageContainer);
    }
  },

  beforeDestroy() {
    document.body.classList.remove("lock-scroll");
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  },
};
</script>

<style lang="scss" scoped>
/* =========================================
   1. 外层容器 & 背景层逻辑
   ========================================= */
.page-scroll-container {
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  /* 兜底背景色 */
  background-color: #1a1a1a;

  /* 移除原有的 background-image，改用 img 标签实现 */
  &::after {
    /* 移除原有的遮罩，现在由 blur-bg 控制 */
    display: none;
  }
}

/* 背景层通用样式 */
.bg-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; /* 防止遮挡交互 */
  user-select: none;
}

/* 底层：清晰图 */
.clear-bg {
  z-index: 0;
  object-fit: cover; /* 保持原有的 cover 效果 */
}

/* 中间层：模糊/变暗图 */
.blur-bg {
  z-index: 1;
  object-fit: cover;
  opacity: 0; /* 默认隐藏 */
  transition: opacity 1.2s ease-in-out; /* 渐变时长 */
  will-change: opacity;

  &.active {
    opacity: 1; /* 进入视野后显示，盖住底层清晰图 */
  }
}

/* =========================================
   2. 核心卡片 (适配逻辑统一)
   ========================================= */
.visual-card {
  position: relative;
  /* 必须高于模糊层 (z-index: 1) */
  z-index: 2;

  /* --- 默认状态：适应主流手机 (6.1 - 6.9英寸) --- */
  width: 100vw;
  height: 100vh;

  /* 移除 CSS 背景图，改用内部 DOM 结构 */
  /* background-image: ...; */
  background: transparent;

  container-type: size;
  isolation: isolate; /* 建立新的层叠上下文 */

  /* 在手机上，1单位 = 1% 屏幕宽度 */
  --unit: 1vw;
}

/* --- 卡片内部背景 (新增) --- */
.card-bg-container {
  position: absolute;
  inset: 0; /* top/left/right/bottom: 0 */
  z-index: -1; /* 放在文字内容下面 */
  overflow: hidden;

  /* 优化渲染 */
  transform: translateZ(0);
  backface-visibility: hidden;

  .card-img {
    width: 100%;
    height: 100%;
    display: block;
    /* 对应原有的 background-size: 100% 100% */
    object-fit: fill;
  }
}

/* --- 卡片内容包装层 (新增，用于统一管理内容) --- */
.card-content {
  width: 100%;
  height: 100%;
  position: relative;
  /* 保持原有内容逻辑 */
}

/* --- 所有子元素的通用样式 (默认倾斜) --- */
.card-content > div {
  position: absolute;
  transform: rotate(-8deg);
  white-space: nowrap;
  font-weight: 600;
  font-family: "MontserratRoman-SemiBold", sans-serif;
  opacity: 0; /* 默认隐藏 */
}

/* --- 1~10 品牌词坐标 (保持不变) --- */
.card-content div:nth-child(1) {
  top: 31%;
  left: 41%;
  color: rgba(91, 42, 21, 0.7);
  font-size: calc(5.3 * var(--unit));
}
.card-content div:nth-child(2) {
  top: 37.5%;
  left: 21.5%;
  color: rgba(91, 42, 21, 0.4);
  font-size: calc(5.3 * var(--unit));
  z-index: 2;
}
.card-content div:nth-child(3) {
  top: 36%;
  right: 27.5%;
  color: #5b2a15;
  font-size: calc(5.3 * var(--unit));
}
.card-content div:nth-child(4) {
  top: 44.5%;
  left: 15.5%;
  color: #5b2a15;
  font-size: calc(5.3 * var(--unit));
}
.card-content div:nth-child(5) {
  top: 42%;
  right: 28.5%;
  color: rgba(91, 42, 21, 0.7);
  font-size: calc(5.3 * var(--unit));
}
.card-content div:nth-child(6) {
  top: 49.5%;
  left: 26.5%;
  color: rgba(91, 42, 21, 0.4);
  font-size: calc(5.3 * var(--unit));
}
.card-content div:nth-child(7) {
  top: 49.5%;
  right: 17%;
  color: #5b2a15;
  font-size: calc(5.3 * var(--unit));
}
.card-content div:nth-child(8) {
  top: 55%;
  left: 19%;
  color: rgba(91, 42, 21, 0.8);
  font-size: calc(4.9 * var(--unit));
  font-family: "MontserratRoman-SemiBold";
}
.card-content div:nth-child(9) {
  top: 57.5%;
  right: 21%;
  color: rgba(91, 42, 21, 0.7);
  font-size: calc(5.3 * var(--unit));
}
.card-content div:nth-child(10) {
  top: 63%;
  left: 31%;
  color: rgba(91, 42, 21, 0.4);
  font-size: calc(4.9 * var(--unit));
  font-family: "MontserratRoman-SemiBold";
}

/* --- 标题 --- */
.main-title {
  bottom: 24%;
  right: 23%;
  color: #ff9b25;
  font-size: calc(6.8 * var(--unit));
  opacity: 0;
  letter-spacing: calc(0.2 * var(--unit));
  .bracket {
    display: inline-block;
    position: relative;
    top: calc(-0.6 * var(--unit));
  }
}

/* --- 弹框通用样式 --- */
.pop-message {
  transform: rotate(0deg);
  white-space: normal;
  font-size: calc(3.2 * var(--unit));
  color: #5b2a15;
  line-height: 1.4;
  text-align: left;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  z-index: 10;
  padding: calc(3 * var(--unit)) calc(4 * var(--unit)) calc(5 * var(--unit))
    calc(4 * var(--unit));
  transform-origin: center center;
}

.nezha-message {
  top: 19%;
  right: 17%;
  width: 55%;
  height: 12%;
  background-image: url("../../../assets/annualReport/nezha_message_bac.png");
  display: flex;
  justify-content: center;
  align-items: center;

  .message-box {
    display: flex;
    flex-direction: column;
    text-align: left;
    justify-content: center;
    align-items: left;
    gap: calc(1.2 * var(--unit));

    .message {
      color: #ff9b25;
      font-size: calc(4 * var(--unit));
      font-weight: 500;
    }
  }
}

.yingtao-message {
  top: 24%;
  left: 9%;
  width: 59%;
  height: 16%;
  background-image: url("../../../assets/annualReport/yingtao_message_bac.png");
  display: flex;
  justify-content: center;
  align-items: center;

  .message-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: left;
    gap: calc(1.2 * var(--unit));
    text-align: left;
    .message {
      color: #ff9b25;
      font-size: calc(4 * var(--unit));
      font-weight: 500;
    }
  }
}

.xiaoma-message {
  top: 30.5%;
  left: 28%;
  width: 55%;
  height: 15%;
  background-image: url("../../../assets/annualReport/nezha_message_bac.png");
  display: flex;
  justify-content: center;
  align-items: center;
  will-change: transform;
  backface-visibility: hidden;
  transform: translateZ(0);

  .message-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: left;
    gap: calc(1.2 * var(--unit));

    .message {
      color: #ff9b25;
      font-size: calc(4 * var(--unit));
      font-weight: 500;
    }
  }
}

.special {
  font-size: calc(4.8 * var(--unit));
  font-family: "MontserratRoman-SemiBold";
  position: relative;
  top: calc(0.3 * var(--unit)); /* 微调：正数向下移动，负数向上移动 */
}

/* --- 适配媒体查询 (保持不变) --- */
@media (min-aspect-ratio: 13/25) {
  .visual-card {
    height: 100vh;
    width: calc(100vh * 390 / 844);
    aspect-ratio: 390 / 844;
    --unit: 0.462vh;
  }
}

@media (max-aspect-ratio: 9/21) {
  .visual-card {
    width: 100vw;
    height: calc(100vw * 844 / 390);
    aspect-ratio: 390 / 844;
    --unit: 1vw;
  }
}

/* --- 动画控制逻辑 (保持不变) --- */
.start-anim {
  /* 
     1. 通用品牌词文字动画：
     原 0.6s -> 改为 1.1s (慢了0.5s) 
  */
  .card-content > div:not(.pop-message) {
    animation: zoomIn 1.1s ease-out forwards;
  }

  /* 文字时间轴 (延迟保持不变，仅调整持续时长) */
  .main-title {
    animation-delay: 0.12s;
  }
  .card-content div:nth-child(2),
  .card-content div:nth-child(6),
  .card-content div:nth-child(10) {
    animation-delay: 0.48s;
  }
  .card-content div:nth-child(1),
  .card-content div:nth-child(5),
  .card-content div:nth-child(9) {
    animation-delay: 0.84s;
  }
  .card-content div:nth-child(8) {
    animation-delay: 1.2s;
  }

  /* 
     2. 特殊弹跳文字 (第3, 4, 7个)：
     animation-duration 原 0.84s -> 改为 1.34s (慢了0.5s) 
  */
  .card-content div:nth-child(3),
  .card-content div:nth-child(4),
  .card-content div:nth-child(7) {
    animation-name: popInText;
    animation-duration: 1.34s;
    animation-timing-function: ease-out;
    animation-delay: 1.56s;
  }

  /* 1. 哪吒 */
  .nezha-message {
    opacity: 0;
    /* 改用 fadeInBreathAndHide */
    animation: fadeInBreathAndHide 2.6s ease-in-out forwards;
    animation-delay: 2.28s;
  }

  /* 2. 樱桃小丸子 */
  .yingtao-message {
    opacity: 0;
    /* 改用 fadeInBreathAndHide */
    animation: fadeInBreathAndHide 2.6s ease-in-out forwards;
    animation-delay: 5s;
  }

  /* 3. 小马宝莉 */
  .xiaoma-message {
    opacity: 0;
    /* 改用 fadeInOnly */
    animation: fadeInOnly 0.86s ease-in-out 7.7s forwards,
      breathingLoop 1.8s ease-in-out 8.56s infinite;
  }
}

/* 1. 哪吒 & 樱桃小丸子：渐现 -> 停留/微呼吸 -> 渐隐 */
@keyframes fadeInBreathAndHide {
  0% {
    opacity: 0;
    transform: scale(0.95); /* 稍微缩小一点点，增加浮现感 */
  }
  20% {
    opacity: 1;
    transform: scale(1); /* 完全显示 */
  }
  60% {
    transform: scale(1.03); /* 极轻微的呼吸，不要太夸张 */
  }
  85% {
    opacity: 1;
    transform: scale(1); /* 准备消失前恢复 */
  }
  100% {
    opacity: 0;
    transform: scale(1); /* 消失 */
  }
}

/* 2. 小马宝莉：只渐现 */
@keyframes fadeInOnly {
  0% {
    opacity: 0;
    transform: scale(0.95);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes breathingLoop {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.06);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale(0.5) rotate(-7deg);
  }
  to {
    opacity: 1;
    transform: scale(1) rotate(-8deg);
  }
}

@keyframes popInText {
  0% {
    opacity: 0;
    transform: scale(0.2) rotate(-7deg);
  }
  60% {
    opacity: 1;
    transform: scale(1.3) rotate(-8deg);
  }
  100% {
    opacity: 1;
    transform: scale(1) rotate(-8deg);
  }
}

.pink-text {
  color: #ff6faf;
}
</style>
